// 📁 Imports
import tippy from "tippy.js";
import "tippy.js/dist/tippy.css";

// 💾 Variables
const tooltip = document.querySelectorAll(".js-tooltip");

// 🖱️ Event listener
if (tooltip.length !== 0) {
  tooltip.forEach((tooltipEl) => {
    let tempalte = tooltipEl.querySelector(".tolltip__template");

    if (tempalte) {
      tempalte = tooltipEl.querySelector(".tolltip__template").innerHTML;
    } else {
      tempalte = "Vložte template";
    }

    tippy(tooltipEl, {
      content: tempalte,
      allowHTML: true,
      interactive: true,
      placement: "auto",
      theme: "custom",
    });
  });
}
